import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import configAxios from './plugins/axios';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

// 循环引入Modules
const files = require.context('./modules', false, /\.js$/);
const modules = {};

files.keys().forEach(key => {
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});

const plugins = [];
debug && plugins.push(createLogger());
plugins.push(configAxios());

export default new Vuex.Store({
  modules,
  strict: debug,
  plugins,
});
